const hamburgerBtn = document.getElementById("hamburgerBtn");
const mobileMenu = document.getElementById("mobileMenu");
const overlay = document.getElementById("dropdownOverlay");
const header = document.getElementById("header");

// Toggle mobile menu
if (hamburgerBtn && mobileMenu) {
    hamburgerBtn.addEventListener("click", function () {
        mobileMenu.classList.toggle("open");
        hamburgerBtn.classList.toggle("is-open");

        const isOpen = mobileMenu.classList.contains("open");

        // Recalculate positions
        updateMobileMenuPosition();

        const headerBottom = header.offsetTop + header.offsetHeight;
        const overlayHeight = window.innerHeight - headerBottom;

        overlay.style.top = `${headerBottom}px`;
        overlay.style.height = `${overlayHeight}px`;

        document.documentElement.classList.toggle("no-scroll", isOpen);
        document.body.classList.toggle("no-scroll", isOpen);
        overlay.classList.toggle("active", isOpen);
    });
}

// Toggle desktop dropdown menus
document.querySelectorAll('.hasDropdown > button').forEach(btn => {
    const dropdownId = btn.getAttribute('data-dropdown');
    const dropdown = document.getElementById(`dropdown-${dropdownId}`);
    if (!dropdown) return;

    btn.setAttribute("aria-haspopup", "true");
    btn.setAttribute("aria-expanded", "false");

    btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const isOpen = dropdown.classList.toggle('open');

        document.querySelectorAll('.dropdownMenu.open').forEach(menu => {
            if (menu !== dropdown) menu.classList.remove('open');
        });

        document.querySelectorAll('.hasDropdown > button').forEach(otherBtn => {
            if (otherBtn !== btn) otherBtn.setAttribute("aria-expanded", "false");
        });

        btn.setAttribute("aria-expanded", isOpen);

        const headerBottom = header.offsetTop + header.offsetHeight;
        overlay.style.top = `${headerBottom}px`;
        overlay.style.height = `calc(100vh - ${headerBottom}px)`;
        overlay.classList.toggle("active", isOpen);
    });
});

// Close desktop dropdowns on outside click
document.addEventListener("click", function (e) {
    if (!e.target.closest(".hasDropdown") && !e.target.closest(".dropdownMenu")) {
        document.querySelectorAll(".dropdownMenu.open").forEach(menu => menu.classList.remove("open"));
        document.querySelectorAll(".hasDropdown > button").forEach(btn => btn.setAttribute("aria-expanded", "false"));
        overlay.classList.remove("active");
    }
});

// Click overlay to close everything
if (overlay) {
    overlay.addEventListener("click", () => {
        // Close desktop dropdowns
        document.querySelectorAll(".dropdownMenu.open").forEach(menu => menu.classList.remove("open"));
        document.querySelectorAll(".hasDropdown > button").forEach(btn => btn.setAttribute("aria-expanded", "false"));

        // Close mobile menu
        if (mobileMenu && mobileMenu.classList.contains("open")) {
            mobileMenu.classList.remove("open");
            hamburgerBtn.classList.remove("is-open");
            document.documentElement.classList.remove("no-scroll");
            document.body.classList.remove("no-scroll");
        }

        // Hide overlay
        overlay.classList.remove("active");
        overlay.style.top = `${headerBottom}px`;
        overlay.style.height = `calc(100vh - ${headerBottom}px)`;
    });
}

// Mobile submenu slide-in logic
document.querySelectorAll(".mobileDropdownTitle").forEach(button => {
    button.addEventListener("click", function () {
        const targetId = button.getAttribute("data-submenu");
        const submenu = document.getElementById(`submenu-${targetId}`);
        if (submenu) {
            submenu.classList.add("active");
            document.documentElement.classList.add("no-scroll");
            document.body.classList.add("no-scroll");
        }
    });
});

document.querySelectorAll(".mobileBackButton").forEach(button => {
    button.addEventListener("click", function () {
        const submenu = button.closest(".mobileSubMenu");
        if (submenu) {
            submenu.classList.remove("active");
        }
    });
});

document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
        document.querySelectorAll(".dropdownMenu.open").forEach(menu => menu.classList.remove("open"));
        document.querySelectorAll(".hasDropdown > button").forEach(btn => btn.setAttribute("aria-expanded", "false"));
        overlay.classList.remove("active");
    }
});

// Dynamic mobile menu position
function updateMobileMenuPosition() {
    if (!header || !mobileMenu) return;
    const headerBottom = header.offsetTop + header.offsetHeight;
    mobileMenu.style.top = `calc(${headerBottom}px - 1px)`;
    mobileMenu.style.height = `calc(100vh - ${headerBottom}px + 2px)`;
    mobileMenu.style.maxWidth = "430px";
    mobileMenu.style.width = "100vw";
}

updateMobileMenuPosition();
window.addEventListener("resize", updateMobileMenuPosition);


/**************
 Mobile Nav
 ***************/

// mobile slider nested dropdown
document.querySelectorAll(".sliderNavDropdownToggle").forEach(element => {
    element.addEventListener("click", function () {
        this.classList.toggle("active");
    });
});

// open nav
function openNav() {
    document.querySelector("#slider").showModal();
    document.querySelector("body").classList.add("noScroll");
}

// close nav
async function closeNav() {
    document.querySelector("#slider").close();
}

// open nav event listener
document.querySelectorAll(".openNav").forEach(element => {
    element.addEventListener("click", openNav);
});

// close nav event listener
document.querySelectorAll(".closeNav").forEach(element => {
    element.addEventListener("click", closeNav);
});